import { useState } from 'react';
import Input2 from '../../../components/input/input-2/Input2';
import TextArea from '../../../components/input/TextArea';
import ScreenReaderOnly from '../../../accessibility/ScreenReaderOnly';
import styles from './name-and-comment.module.less';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import {
    COMMENT_DESCRIPTION_TEXT_KEY,
    COMMENT_PLACEHOLDER_TEXT_KEY,
    COMMENT_TOO_LONG_ERROR_TEXT_KEY,
    LEAVE_COMMENT_TEXT_KEY,
    LEAVE_NAME_TEXT_KEY,
    NAME_TOO_LONG_ERROR_TEXT_KEY,
    NO_NAME_ERROR_TEXT_KEY,
    YOUR_NAME_TEXT_KEY,
} from '../../i18n/project-i18n-model';

const NameAndComment = ({ name, setName, comment, setComment, className }) => {
    const [inputErrors, setInputErrors] = useState({});

    const texts = useI18nTexts([
        NO_NAME_ERROR_TEXT_KEY,
        NAME_TOO_LONG_ERROR_TEXT_KEY,
        COMMENT_TOO_LONG_ERROR_TEXT_KEY,
        LEAVE_NAME_TEXT_KEY,
        YOUR_NAME_TEXT_KEY,
        LEAVE_COMMENT_TEXT_KEY,
        COMMENT_PLACEHOLDER_TEXT_KEY,
        COMMENT_DESCRIPTION_TEXT_KEY,
    ]);

    const validateName = () => {
        let nameErrorMessage;
        if (name?.length === 0 && comment?.length > 0) {
            nameErrorMessage = texts[NO_NAME_ERROR_TEXT_KEY];
        } else if (name?.length > 200) {
            nameErrorMessage = texts[NAME_TOO_LONG_ERROR_TEXT_KEY];
        }
        setInputErrors({ ...inputErrors, name: nameErrorMessage });

        return !nameErrorMessage;
    };

    const validateComment = () => {
        let commentErrorMessage;
        if (comment?.length > 200) {
            commentErrorMessage = texts[COMMENT_TOO_LONG_ERROR_TEXT_KEY];
        }
        setInputErrors({ ...inputErrors, comment: commentErrorMessage });

        return !commentErrorMessage;
    };

    return (
        <div className={className}>
            <ScreenReaderOnly id="input-name-and-comment-block">{texts[LEAVE_NAME_TEXT_KEY]}</ScreenReaderOnly>
            <Input2
                title={texts[YOUR_NAME_TEXT_KEY]}
                fieldName="name"
                errors={inputErrors}
                value={name}
                onChange={(e) => {
                    setName(e.target.value);
                }}
                onBlur={validateName}
            />
            <TextArea
                className={styles.messageInput}
                title={texts[LEAVE_COMMENT_TEXT_KEY]}
                rows={2}
                fieldName="comment"
                maxLength="200"
                errors={inputErrors}
                value={comment}
                onChange={(e) => {
                    setComment(e.target.value);
                    validateComment();
                }}
                onBlur={validateComment}
                placeholder={texts[COMMENT_PLACEHOLDER_TEXT_KEY]}
                fieldDescription={texts[COMMENT_DESCRIPTION_TEXT_KEY]}
                countLimit={200}
            />
        </div>
    );
};

export default NameAndComment;
